import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { TRFPListResponse, TRPFListRequest } from './types'
import { ResponseWithPagination, TOptionsResponse } from '../../../constants'

const fetcher = new Fetcher({})

export const getRfpList = async (data) =>
  fetcher.request<TRPFListRequest, TRFPListResponse>({
    url: API_DICTIONARY.RFP,
    method: HTTP_METHODS.GET,
    ...data
  })

export const fetchLedBy = async () =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.RFP}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.LED_BY}`,
    method: HTTP_METHODS.GET
  })
